<template>
  <div>
    <div style="margin-top: -20px">
      <el-input
        size="small"
        placeholder="请输入内容搜索"
        class="input-with-select"
        v-model="search.word"
        clearable
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="reSearch"
        ></el-button>
      </el-input>
    </div>
    <div
      style="
        height: 50vh;
        overflow-y: auto;
        margin-bottom: 80px;
        margin-top: 10px;
      "
    >
      <el-row
        align="middle"
        justify="start"
        v-for="item in list"
        style="
          border-bottom: 1px solid #eee;
          text-align: left;
          padding-left: 5px;
          margin-top: 10px;
        "
      >
        <div
          :style="{
            fontSize: '16px',
            color: item.name == selectItem.name ? '#2290ef' : '#000',
          }"
          @click="selectItem = item"
        >
          {{ item.name }}
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-content: space-around;
            margin-top: 5px;
            font-size: 13px;
            margin-bottom: 10px;
            color: #666;
          "
          @click="selectItem = item"
        >
          <span>{{ item.customer }}</span
          ><span>{{ item.province }}{{ item.city }}{{ item.area }}</span>
        </div>
      </el-row>
      <div style="margin-top: 15px">
        <el-button size="mini" @click="loadNext()" v-if="!search.loadover"
          >加载更多</el-button
        >
      </div>
    </div>
    <div
      style="
        position: absolute;
        left: 0;
        width: 100%;
        text-align: center;
        bottom: 10px;
      "
    >
      <el-button type="primary" @click="setUser">确定</el-button>
    </div>
  </div>
</template> 
<script>
export default {
  name: "sel_engineer",
  components: {},
  data() {
    return {
      list: [],
      selectItem: {},
      search: {
        word: "",
        page: 0,
        limit: 10,
        loadover: false,
      },
    };
  },
  methods: {
    showInfo() {
      this.search.word = "";
      this.search.page = 0;
      this.search.loadover = false;
      this.checklist = [];
      this.loadNext();
    },
    reSearch() {
      this.search.page = 0;
      this.search.loadover = false;
      this.checklist = [];
      this.loadNext();
    },
    async loadNext() {
      if (this.search.loadover) {
        return;
      }

      var data = await this.$api.request.get("/engineer/pager_list", {
        params: this.search,
      });
      if (this.search.page == 0) {
        this.list = [];
        this.list = data;
      } else {
        this.list = this.list.concat(data);
      }
      if (data.length == this.search.limit) {
        this.search.page += 1;
      } else {
        this.search.loadover = true;
      }
    },
    setUser() {
      if (!this.selectItem.name) {
        return;
      }
      this.$emit("engineerSelected", this.selectItem);
    },
  },
};
</script>